/*
 * @Author       : dengjianjun
 * @Date         : 2021-10-22 15:55:32
 * @LastEditors: zhuyating zhuyating@didichuxing.com
 * @LastEditTime: 2024-01-08 17:36:20
 * @Description  :
 * @FilePath     : /es-template/src/store/modules/train/state.js
 */

import { getStorage } from '@/utils/storage'
import {
  STORAGE_HISTORY_LIST,
  STORAGE_CITY_HISTORY_LIST,
  STORAGE_TRAVEL_TYPE,
  STORAGE_ERROR_MSG,
  HOME_SELECTED_DATE
} from '@/utils/train-storage';

const LAST_SEARCH_CITY_LIST = getStorage(STORAGE_HISTORY_LIST)?.[0]
import { compare } from '@didi/es-mpx-shared';
import { getNextDay } from '@/utils/baseDate';
const DEFAULT_FROM_CITY = {
  id: '1',
  name: '北京',
  subName: '北京',
  precise_search: '0'
}
const DEFAULT_TO_CITY = {
  id: '4',
  name: '上海',
  subName: '上海',
  precise_search: '0'
}
const localDate = getStorage(HOME_SELECTED_DATE)
const nextDayTimeStamp = getNextDay(new Date().getTime())
const todayTimeStamp = new Date().setHours(0, 0, 0, 0)
const selectDate  = localDate ? (localDate < todayTimeStamp ? nextDayTimeStamp : localDate) : nextDayTimeStamp
export default {
  DEFAULT_FROM_CITY,
  DEFAULT_TO_CITY,
  trainCities: {}, // 城市列表
  trainHotCities: [], // 热门城市列表
  requisition_list: [], // 差旅制度list
  institution_list: [], // 无需审批制度列表
  travel: {}, // 除了差旅单的内容
  currentTravel: {}, // 当前差旅
  travelInfoContent: [], // 差旅制度
  currentFromCity: LAST_SEARCH_CITY_LIST?.[0] ?? {}, //因公出发地城市
  currentToCity: LAST_SEARCH_CITY_LIST?.[1] ?? {}, //因公目的地城市
  personalCity: getStorage('personalCity') || {}, //因私目的地城市
  travelList: [], // 差旅列表
  // 出行类型标识 0-因公默认，1-因私
  travelType: getStorage(STORAGE_TRAVEL_TYPE) || 0,
  selectDate: selectDate,
  historyList: getStorage(STORAGE_HISTORY_LIST) || [], // 历史记录
  cityHistoryList: getStorage(STORAGE_CITY_HISTORY_LIST) || [],
  searchedCityList: [], // 搜索城市列表
  hot_city_list: [], // 热门城市
  allCityList: [], // 所有城市
  errorMsg: getStorage(STORAGE_ERROR_MSG) || [],
}
